"use client";

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HomeIcon, Loader, Loader2 } from "lucide-react";
import { deleteAccountService } from "../services/profile";
import { errorToast } from "../utils/toasters";

export default function DeleteAccountPage() {
  const [isDeleting, setIsDeleting] = useState(true);
  const navigate = useNavigate();

  useEffect(
    () => {
      async function deleteAccount() {
        try {
          const deleteAccountResponse = await deleteAccountService();
          localStorage.clear()
          navigate("/home");
        } catch (error) {
          console.error("Error while deleting your account: ", error);
          errorToast(
            "Error while deleting account. Try again after some time."
          );
        } finally {
          setIsDeleting(false);
        }
      }

      deleteAccount();
    },
    [navigate]
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 font-afacad">
      <div className="relative w-full max-w-md mx-auto p-8 bg-white rounded-lg shadow-lg">
        {isDeleting ? (
          <div className="text-center">
            <div className="mb-4">
              <Loader2 className="animate-spin text-purple-600 h-16 w-16 mx-auto" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900">
              Deleting your account...
            </h2>
            <p className="mt-4 text-gray-500">
              This might take a few seconds. Please wait while we process your
              request.
            </p>
          </div>
        ) : (
          <div className="text-center">
            <HomeIcon className="text-green-500 h-16 w-16 mx-auto" />
            <h2 className="text-3xl font-bold text-gray-900">
              Account Deleted
            </h2>
            <p className="mt-4 text-gray-500">
              Your account has been successfully deleted. You will be redirected
              to the homepage.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
